module.exports = __webpack_public_path__ + "img/chair_rendered.d55a9378.jpg";